import { render, staticRenderFns } from "./RoleCRDialog.vue?vue&type=template&id=7b160760&scoped=true"
import script from "./RoleCRDialog.vue?vue&type=script&lang=js"
export * from "./RoleCRDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b160760",
  null
  
)

export default component.exports